import { SVGProps } from "react"
const Phone2Icon = (props: SVGProps<SVGSVGElement>) => (
  <svg
    width="20"
    height="20"
    viewBox="0 0 20 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M6.92578 10.05C7.56892 11.3781 8.64287 12.4493 9.97266 13.089C10.0707 13.1355 10.1792 13.1556 10.2875 13.1473C10.3957 13.1391 10.4999 13.1029 10.5898 13.0421L12.543 11.7375C12.6293 11.6789 12.729 11.6432 12.8328 11.6337C12.9366 11.6241 13.0412 11.641 13.1367 11.6828L16.793 13.2531C16.9179 13.3051 17.0223 13.3967 17.0901 13.5139C17.1578 13.6311 17.1852 13.7673 17.168 13.9015C17.0521 14.806 16.6106 15.6373 15.9261 16.2398C15.2417 16.8423 14.3611 17.1747 13.4492 17.175C10.6313 17.175 7.92878 16.0555 5.93621 14.063C3.94364 12.0704 2.82422 9.36788 2.82422 6.54995C2.82442 5.63808 3.15689 4.75752 3.7594 4.07304C4.3619 3.38857 5.19317 2.94709 6.09766 2.8312C6.23191 2.81396 6.3681 2.84132 6.48527 2.90908C6.60244 2.97684 6.69408 3.08124 6.74609 3.2062L8.31641 6.87026C8.35724 6.96429 8.37433 7.06691 8.36615 7.16909C8.35798 7.27127 8.3248 7.36987 8.26953 7.4562L6.96484 9.44058C6.90676 9.53033 6.87267 9.63348 6.86583 9.74017C6.85899 9.84686 6.87963 9.95352 6.92578 10.05V10.05Z"
      stroke={props.color || "#011727"}
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
)

export default Phone2Icon
